// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "",
    "hash": "",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "",
    "semverString": null,
    "version": "0.0.0"
};
/* tslint:enable */
